import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export interface ProjectUrlParams {
  requestId?: string;
  accountId?: string;
  opportunityId?: string;
  rawProjectId?: string;
  docusignLink?: string;
}

export const useProjectUrlParams = (): ProjectUrlParams => {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const getParam = (key: string) => {
      const value = searchParams.get(key);
      return value || undefined;
    };

    const contractLink = getParam('contractLink');
    const decodedContractLink = contractLink ? decodeURIComponent(contractLink) : undefined;

    return {
      requestId: getParam('requestId'),
      accountId: getParam('accountId'),
      opportunityId: getParam('opportunityId'),
      rawProjectId: getParam('rawProjectId'),
      plannedSowSigningDate: getParam('plannedSowSigningDate') ?? null,
      docusignLink: decodedContractLink,
    };
  }, [searchParams]);
};
